function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var toVar = (value, fallback) => ({
  var: value,
  varRef: fallback ? "var(".concat(value, ", ").concat(fallback, ")") : "var(".concat(value, ")")
});
export var cssVars = {
  arrowShadowColor: toVar('--popper-arrow-shadow-color'),
  arrowSize: toVar('--popper-arrow-size', '8px'),
  arrowSizeHalf: toVar('--popper-arrow-size-half'),
  arrowBg: toVar('--popper-arrow-bg'),
  transformOrigin: toVar('--popper-transform-origin'),
  arrowOffset: toVar('--popper-arrow-offset')
};
export function getBoxShadow(placement) {
  if (placement.includes('top')) return "1px 1px 1px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes('bottom')) return "-1px -1px 1px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes('right')) return "-1px 1px 1px 0 var(--popper-arrow-shadow-color)";
  if (placement.includes('left')) return "1px -1px 1px 0 var(--popper-arrow-shadow-color)";
  return "1px 1px 1px 0 var(--popper-arrow-shadow-color)";
}
var transforms = {
  top: 'bottom center',
  'top-start': 'bottom left',
  'top-end': 'bottom right',
  bottom: 'top center',
  'bottom-start': 'top left',
  'bottom-end': 'top right',
  left: 'right center',
  'left-start': 'right top',
  'left-end': 'right bottom',
  right: 'left center',
  'right-start': 'left top',
  'right-end': 'left bottom'
};
export var toTransformOrigin = placement => transforms[placement];
var defaultEventListeners = {
  scroll: true,
  resize: true
};
export function getEventListenerOptions(value) {
  var eventListeners;
  if (typeof value === 'object') {
    eventListeners = {
      enabled: true,
      options: _objectSpread(_objectSpread({}, defaultEventListeners), value)
    };
  } else {
    eventListeners = {
      enabled: value,
      options: defaultEventListeners
    };
  }
  return eventListeners;
}